import { useState } from 'react';

//* HOC's
import { withLanguageContext, withUserContext } from '@/context';

//* Components
import Text from '@/components/common/Text';
import Button from '@/components/common/Button';
import CustomRate from '@/components/common/CustomRate';
import FormItem from '@/components/common/Form/FormItem';
import FormInput from '@/components/common/Form/FormInput';
import FormContainer from '@/components/common/Form/FormContainer';

//* Style
import ProductReviewFormSectionStyle from './style';

const ProductReviewFormSection = ({ productId, translate, isLoggedIn, createReview }) => {
    //! State
    const [success, setSuccess] = useState(false);

    //! Handle Review
    const handleReview = (values) => {
        return createReview({
            ...values,
            productId
        }).then(() => {
            setSuccess(true)

            setTimeout(() => {
                setSuccess(false)
            }, 4000)
        })
    };

    return isLoggedIn ? (
        <ProductReviewFormSectionStyle>
            <Text
                className={'h2-L font-futura-medium form-review-title'}
                text={'letKnowThink'}
            />

            <FormContainer initialValues={{ rating: 5 }} onFinish={handleReview}>
                <FormItem
                    name={'rating'}
                    required={false}
                    label={translate('formReviewSubtitle')}>
                    <CustomRate
                        disabled={false}
                        hasLabel={false}
                    />
                </FormItem>

                <div className='review-form-col'>
                    <FormItem
                        name={'content'}
                        label={translate('reviewTitleWithSymbol')}>
                        <FormInput
                            isTextAreaInput
                            placeholder={translate('reviewPlaceholder')}
                        />
                    </FormItem>
                </div>

                {success ? (
                    <Text
                        className={'h2-L font-futura-medium green success-text'}
                        text={'successReviewText'}
                    />
                ) : (
                    <div className='review-btn-col'>
                        <Button
                            type={'submit'}
                            text={'saveReview'}
                        />
                    </div>
                )}
            </FormContainer>
        </ProductReviewFormSectionStyle>
    ) : null;
};

export default withUserContext(withLanguageContext(ProductReviewFormSection, ['translate']), ['isLoggedIn', 'createReview']);
